import "core-js/modules/es.object.to-string.js";
/**
 * A shim for Array.group which isn't widely supported by browsers
 */

export default function groupBy(
/**
 * Array to group
 */
array,
/**
 * Function that must return a valid group name
 * when called with an item of the array
 */
getItemGroup) {
  var groups = array.reduce(function (obj, curr) {
    var _obj$group;
    var group = getItemGroup(curr);
    (_obj$group = obj[group]) !== null && _obj$group !== void 0 ? _obj$group : obj[group] = [];
    obj[group].push(curr);
    return obj;
  }, {});

  // We're casting the object values to be potentially undefined
  // as not every group key may have been populated.
  return groups;
}